module.exports = __webpack_public_path__ + "img/404_headline.0003a5d6.jpg";